import React, { useContext } from "react";
import * as tasks from "../extended/December2024Tasks";
import { MaturaReviewContext } from "../../components/MaturaExamRunner/MaturaReviewContext";
import MaturaOriginalSourceLinks from "../../components/MaturaOriginalSourceLinks";
import MaturaPdfPreview from "../../components/MaturaPdfPreview";
export const sheet = { id: "cke-r-2024-grudzien", title: "Matura rozszerzona — próbny grudzień 2024", subtitle: "Podgląd administratora · 14 punktowanych części · 50 punktów", sourceLabel: "CKE · grudzień 2024 · rozszerzenie", taskCount: 14, maxPoints: 50, sessionType: "trial" };
const taxonomy = { "1": ["2:4", "3_6_4"], "2": ["9:1", "10_2_1"], "3": ["7:2", "8_3_1"],
  "4": ["9:0", "10_1_2"], "5": ["8:1", null], "6": ["1:2", "2_2_6"],
  "7": ["6:2", "7_3_3"], "8": ["2:5", null], "9": ["4:2", "5_3_2"],
  "10": ["3:1", "4_2_1"], "11": ["2:3", "3_3_7"], "12": ["5:0", "6_1_1"],
  "13.1": ["9:1", "10_2_1"], "13.2": ["2:5", "3_7_4"] };
export const classification = tasks.taskNumbers.map(taskNo => ({ taskNo,
  sectionKey: String(Number(taxonomy[taskNo][0].split(":")[0]) + 1), topicKey: taxonomy[taskNo][0], subtopicId: taxonomy[taskNo][1],
  maxPoints: tasks.definitions[taskNo].points, familyKey: tasks.definitions[taskNo].family, topic: tasks.definitions[taskNo].topic, status: "ready" }));
export function generateTaskVariant(number, variant = "random", options = {}) {
  number = String(number);
  if (number.startsWith("13.") && !options.single) {
    const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
    const linkedTasks = ["13.1", "13.2"].map(n => generateTaskVariant(n, variant, { ...options, seed, single: true }));
    return { ...linkedTasks.find(row => row.meta.taskNo === number), linkedTasks };
  }
  const task = tasks.generateTask(number, { ...options, variant });
  return { index: tasks.taskNumbers.indexOf(number), task: { ...task, displayBaseNumber: Number(number.split(".")[0]) }, meta: { ...classification.find(row => row.taskNo === number), quizTypeKey: task.type, quizKind: "open", assessmentMode: "self" } };
}
export function generatePagedTasks(variant = "original", options = {}) {
  const seed = options.seed ?? `${Date.now()}-${Math.random()}`;
  return tasks.taskNumbers.map(number => generateTaskVariant(number, variant, { ...options, single: true, seed: `${seed}:${number.startsWith("13.") ? "graph" : number}` }));
}
export function generateTasks(variant, options) { return generatePagedTasks(variant, options).map(row => row.task); }
export const getVariantCounts = tasks.getVariantCounts;
function OriginalLink({ task }) {
  const review = useContext(MaturaReviewContext);
  if (review.interactive && !review.reviewAllowed) return null;
  return <MaturaPdfPreview url={tasks.pdfUrl("arkusz", task.taskNumber)} title={`Arkusz CKE · grudzień 2024 · zadanie ${task.taskNumber}`} label="Zadanie w oryginalnym PDF · grudzień 2024"/>;
}
export function renderTask(task) { return <>{tasks.renderTask(task)}<MaturaOriginalSourceLinks task={task}/><OriginalLink task={task}/></>; }
export const renderInput = tasks.renderInput;
export const checkAnswer = tasks.checkAnswer;
export const renderAnswer = tasks.renderAnswer;
export const renderExplanation = tasks.renderExplanation;
export const renderUserAnswer = tasks.renderUserAnswer;
export function getInteractionSupport() { return { renderInput: true, checkAnswer: true, renderUserAnswer: true }; }
